import { useState } from 'react';
import classNames from 'classnames';
import { Button } from 'react-bootstrap';
import DiscountDrawer from 'components/DiscountDrawer';
import { OPEN_DISCOUNT_DRAWER } from 'constants/gtm';
import { sendUserInteractionEvent } from 'utils/metrics';
import styles from './ProductDiscountsInfo.module.scss';

const ProductDiscountsInfo = ({
  containerCustomStyling,
  discounts = [],
  groupedDiscountsContent,
  mainSpanCustomStyling,
  showMoreCustomStyling,
}) => {
  const [showDiscountDrawer, setShowDiscountDrawer] = useState(false);

  const toggleDiscountDrawer = () => {
    setShowDiscountDrawer((val) => !val);
    if (!showDiscountDrawer) {
      sendUserInteractionEvent(OPEN_DISCOUNT_DRAWER);
    }
  };

  const mainAppliedStyling = mainSpanCustomStyling ?? ' fs-6 fs-md-7 fw-600';
  const showMoreAppliedStyling =
    showMoreCustomStyling ?? ' fs-6 fs-md-7 fw-600';

  let otherDiscountsCount = 0;
  const groupKeyCounted = {};
  groupKeyCounted[discounts[0]?.groupKey ?? ''] = true;
  for (let i = 1; i < discounts.length; i++) {
    const { groupKey } = discounts[i];
    if (!groupKey || !groupKeyCounted[groupKey]) {
      otherDiscountsCount++;
      groupKeyCounted[groupKey] = true;
    }
  }

  const firstDiscountGroupContent = groupedDiscountsContent?.find(
    (x) => x.discount_id?.toLowerCase() === discounts[0]?.groupKey
  );
  const discountName =
    firstDiscountGroupContent?.online_name ||
    discounts[0]?.onlineNameOverride ||
    discounts[0]?.onlineName;

  return discounts.length > 0 ? (
    <>
      <div className={classNames(containerCustomStyling)}>
        <Button
          aria-label="Open Available Discounts Drawer"
          className="p-0"
          data-value="open-discounts-drawer"
          variant="none"
          type="button"
          onClick={toggleDiscountDrawer}
        >
          <div
            className={classNames(
              'px-2 py-2',
              { 'mb-2': discounts.length > 1 },
              mainAppliedStyling,
              styles.discount_info
            )}
          >
            {discountName}
          </div>
          {otherDiscountsCount > 0 && (
            <div
              className={classNames(
                'px-2 py-2',
                showMoreAppliedStyling,
                styles.discount_info
              )}
            >
              {otherDiscountsCount === 1
                ? ` + ${otherDiscountsCount} More Special`
                : ` + ${otherDiscountsCount} More Specials`}
            </div>
          )}
        </Button>
      </div>
      <DiscountDrawer
        showDrawer={showDiscountDrawer}
        discountData={discounts}
        groupedDiscountsContent={groupedDiscountsContent}
        toggleDrawer={toggleDiscountDrawer}
      />
    </>
  ) : null;
};
export default ProductDiscountsInfo;
